import store from '@/store'

const toggleThemeMode = modeToggle => {
  let preferences = {...store.getters.pref}
  const body = document.querySelector('body')
  if (modeToggle) {
    preferences.appearance.mode = 'dark'
    body.classList.add('_mode_dark')
  } else {
    preferences.appearance.mode = 'light'
    body.classList.remove('_mode_dark')
  }
  preferences = {...preferences, ...store.getters.pref}
  store.dispatch('SET_PREFERENCES', preferences)
}

export const validateActiveMode = () => {
  store.dispatch('GET_PREFERENCES').then(() => {
    const preferences = {...store.getters.pref}
    if (preferences.appearance.mode === 'dark') return true
    else if (preferences.appearance.mode === 'light') return false
    else return false
  })
}

export const applyThemeModeOnBody = () => {
  const activeMode = store.getters.pref.appearance.mode
  const body = document.querySelector('body')

  if (activeMode === 'dark') body.classList.add('_mode_dark')
  else body.classList.remove('_mode_dark')
}

export default toggleThemeMode
